import IntlService from "ember-intl/services/intl";

/**
 * Returns the translation or the default option if no translation is found.
 */
export default function tWithDefault(intl, key, defaultOption) {
  const translation = intl.lookup(key, "fr-fr", {
    resilient: true
  });
  return translation ? translation : defaultOption;
}

/**
 * This is usefull if we want to merge several translation base key.
 * @example tWithBaseKeys(intl, ["consultation-history", "consultation-report-types"], "dentist" )
 */
export function tWithBaseKeys(intl, baseKeys, key) {
  for (let i = 0; i < baseKeys.length; i++) {
    const translation = intl.lookup(`${baseKeys[i]}.${key}`, "fr-fr", {
      resilient: true
    });
    if (translation) {
      return translation;
    }
  }
  return `Missing translation "[${baseKeys.join(",")}].${key}"`;
}